import './bml-about-work-banner.scss';
const TEMPLATE = `
<section class="main-banner-about-work fade-up">
    <!-- Контейнер з білими колами -->
    <div class="work-circles-wrapper" data-animate-circles>
        <!-- Білі кола -->
        <div class="work-circle work-circle-extra-large"></div>
        <div class="work-circle work-circle-large"></div>
        <div class="work-circle work-circle-medium"></div>
    </div>

    <div class="container-fluid">
        <h1 data-animate-child data-delay="200">Точність, якій довіряють лікарі.</h1>
        <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6">
                <p class="about-work-feed-banner" data-animate-child data-delay="400">Сучасна лабораторна діагностика BML для клінічних рішень, де важлива експертність, швидкість і надійність результату.</p>
            </div>
        </div>
    </div>
</section>
`;

class BmlAboutWorkBanner extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-about-work-banner', BmlAboutWorkBanner);
